import { render } from "./ProsesDokumen.vue?vue&type=template&id=064251b7"
import script from "./ProsesDokumen.vue?vue&type=script&lang=js"
export * from "./ProsesDokumen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__